import request from './request';

/**
 * 检查用户是否已登录
 * 
 * @returns {Promise<boolean>} 返回Promise，解析为布尔值表示用户是否已登录
 */
export function checkUserLogin() {
  return request({
    url: '/user/isLoin',
    method: 'get'
  });
} 